"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Card = function Card(_ref) {
  var className = _ref.className,
      children = _ref.children;
  var cls = (0, _classnames.default)(className, 'py-2 px-5 shadow border rounded-xl');
  return /*#__PURE__*/_react.default.createElement("div", {
    className: cls
  }, children);
};

Card.propTypes = {
  children: _propTypes.default.any,
  className: _propTypes.default.string
};
var _default = Card;
exports.default = _default;